// styles
import styled from 'styled-components';

const SoFormStepSuccessFooter = styled.div``;

export default SoFormStepSuccessFooter;
